import { PractitionerEntityType } from "@/lib/supabase/supabaseTypes";

export const practitionerExample: PractitionerEntityType = {
	id: 1234567890,
	created_at: "2021-06-29T15:00:00Z",
	modified_at: "2021-06-29T15:00:00Z",
	organization_id: "123e4567-e89b-12d3-a456-426614174000",
	title: "Herr",
	first_name: "Max",
	last_name: "Mustermann",
	profile_id: "123e4567-e89b-12d3-a456-426614174000",
	email: "max.mustermann@example.com",
	client_id: "123e4567-e89b-12d3-a456-426614174000",
};
